// extracted by mini-css-extract-plugin
module.exports = {"btnApply":"dropdown-with-apply_btnApply__KjruB"};